import { Button } from "../ui/button";
import { ArrowRight } from "lucide-react";

const FinalCTA = () => {
  return (
    <section className="bg-gradient-dark py-12 text-background lg:py-14">
      <div className="container-tight">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-balance text-3xl font-semibold leading-tight tracking-tight text-background sm:text-4xl lg:text-5xl">
            Before the next AI initiative, know where it will actually <span className="font-serif italic text-signal-glow">deliver impact</span>.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-background/70">
            Signal AI helps you move from AI conversations → measurable outcomes.
          </p>
          <p className="mt-4 text-base text-background/80">
            Start with clarity get started with Signal AI at <span className="font-semibold text-signal-glow">$0</span>.
          </p>
          <div className="mt-10">
            <Button asChild size="lg" className="group h-12 rounded-full bg-background px-7 text-base text-foreground hover:bg-background/90">
              <a href="/assessment">
                Start Your Assessment
                <ArrowRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
